// import React, { useState, useEffect } from "react";
// import { Modal, Button, Table, Form, Spinner } from "react-bootstrap";
// import { FaSearch, FaTrash } from "react-icons/fa";
// import { Pencil } from "lucide-react";
// import Swal from "sweetalert2";
// import "sweetalert2/dist/sweetalert2.min.css";

// const API_URL = "https://kaasbackend.vetrinahealthcare.com/master/educations/";

// const EducationManager = () => {
//   const [educations, setEducations] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [editingItem, setEditingItem] = useState(null);
//   const [educationName, setEducationName] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");

//   const [isPageLoading, setIsPageLoading] = useState(false);
//   const [isActionLoading, setIsActionLoading] = useState(false);
//   const [isDeletingId, setIsDeletingId] = useState(null);

//   const token = localStorage.getItem("jwttoken");

//   useEffect(() => {
//     fetchEducations();
//   }, []);

//   const fetchEducations = async () => {
//     setIsPageLoading(true);
//     try {
//       const res = await fetch(API_URL, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       if (!res.ok) {
//         const error = await res.json();
//         Swal.fire(
//           "Error",
//           error.detail || "Failed to fetch educations",
//           "error"
//         );
//         return;
//       }
//       const data = await res.json();
//       setEducations(data);
//     } catch (err) {
//       Swal.fire("Error", "Network error", "error");
//     } finally {
//       setIsPageLoading(false);
//     }
//   };

//   const handleShowModal = (item = null) => {
//     if (item) {
//       setEditingItem(item);
//       setEducationName(item.name);
//     } else {
//       setEditingItem(null);
//       setEducationName("");
//     }
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setEditingItem(null);
//     setEducationName("");
//   };

//   const handleAddOrEdit = async () => {
//     const trimmed = educationName.trim();
//     if (!trimmed) {
//       Swal.fire("Validation", "Education name is required!", "warning");
//       return;
//     }

//     setIsActionLoading(true);

//     if (editingItem) {
//       // PATCH
//       try {
//         const res = await fetch(`${API_URL}${editingItem.id}/`, {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });
//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire("Error", error.detail || "Failed to update", "error");
//           return;
//         }
//         Swal.fire("Updated!", "Education updated successfully.", "success");
//         fetchEducations();
//         handleCloseModal();
//       } catch (err) {
//         Swal.fire("Error", "Network error", "error");
//       } finally {
//         setIsActionLoading(false);
//       }
//     } else {
//       // POST
//       try {
//         const res = await fetch(API_URL, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });
//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire("Error", error.detail || "Failed to add", "error");
//           return;
//         }
//         Swal.fire("Added!", "Education added successfully.", "success");
//         fetchEducations();
//         handleCloseModal();
//       } catch (err) {
//         Swal.fire("Error", "Network error", "error");
//       } finally {
//         setIsActionLoading(false);
//       }
//     }
//   };

//   const deleteEducation = async (item) => {
//     const confirm = await Swal.fire({
//       title: "Are you sure?",
//       text: `Delete "${item.name}"?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (confirm.isConfirmed) {
//       setIsDeletingId(item.id);
//       try {
//         const res = await fetch(`${API_URL}${item.id}/`, {
//           method: "DELETE",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire("Error", error.detail || "Failed to delete", "error");
//           return;
//         }
//         Swal.fire("Deleted!", "Education deleted successfully.", "success");
//         fetchEducations();
//       } catch (err) {
//         Swal.fire("Error", "Network error", "error");
//       } finally {
//         setIsDeletingId(null);
//       }
//     }
//   };

//   const filteredEducations = educations.filter((item) =>
//     item.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div>
//       <h4 className="mb-3 text-center">Education Management</h4>

//       <div className="d-flex justify-content-between mb-3">
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             width: "300px",
//           }}
//         >
//           <FaSearch
//             style={{
//               position: "absolute",
//               left: "10px",
//               color: "#888",
//             }}
//           />
//           <input
//             type="text"
//             placeholder="Search Education..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               padding: "8px 10px 8px 35px",
//               border: "1px solid #ddd",
//               borderRadius: "5px",
//               width: "100%",
//             }}
//           />
//         </div>

//         <Button
//           onClick={() => handleShowModal()}
//           style={{
//             background: "linear-gradient(135deg, #ff5baf, #7366ff)",
//             color: "white",
//             border: "none",
//           }}
//         >
//           + Add Education
//         </Button>
//       </div>

//       {isPageLoading ? (
//         <div className="text-center my-5">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <Table striped hover responsive>
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Education Name</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredEducations.length > 0 ? (
//               filteredEducations.map((item) => (
//                 <tr key={item.id}>
//                   <td>{item.id}</td>
//                   <td>{item.name}</td>
//                   <td>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       className="me-2"
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#7366ff",
//                         cursor: "pointer",
//                       }}
//                       onClick={() => handleShowModal(item)}
//                     >
//                       <Pencil size={20} />
//                     </Button>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#ff5370",
//                         cursor: "pointer",
//                       }}
//                       onClick={() => deleteEducation(item)}
//                       disabled={isDeletingId === item.id}
//                     >
//                       {isDeletingId === item.id ? (
//                         <Spinner size="sm" animation="border" />
//                       ) : (
//                         <FaTrash size={20} />
//                       )}
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="3" className="text-center">
//                   No Education Found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {editingItem ? "Edit Education" : "Add Education"}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="educationName">
//               <Form.Label>Education Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={educationName}
//                 onChange={(e) => setEducationName(e.target.value)}
//                 placeholder="Enter education name"
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={handleCloseModal}
//             disabled={isActionLoading}
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             style={{
//               background: "linear-gradient(135deg, #ff5baf, #7366ff)",
//               color: "white",
//               border: "none",
//             }}
//             onClick={handleAddOrEdit}
//             disabled={isActionLoading}
//           >
//             {isActionLoading ? (
//               <Spinner size="sm" animation="border" />
//             ) : editingItem ? (
//               "Save Changes"
//             ) : (
//               "Add Education"
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default EducationManager;


import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Form, Spinner, Pagination } from "react-bootstrap";
import { FaSearch, FaTrash } from "react-icons/fa";
import { Pencil } from "lucide-react";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const API_URL = "https://kaasbackend.vetrinahealthcare.com/master/educations/";

const EducationManager = () => {
  const [educations, setEducations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [educationName, setEducationName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isDeletingId, setIsDeletingId] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const token = localStorage.getItem("jwttoken");

  useEffect(() => {
    fetchEducations();
  }, []);

  const fetchEducations = async () => {
    setIsPageLoading(true);
    try {
      const res = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) {
        const error = await res.json();
        Swal.fire(
          "Error",
          error.detail || "Failed to fetch educations",
          "error"
        );
        return;
      }
      const data = await res.json();
      setEducations(data);
      setCurrentPage(1); // Reset to first page on data load
    } catch (err) {
      Swal.fire("Error", "Network error", "error");
    } finally {
      setIsPageLoading(false);
    }
  };

  // Filter educations based on search term
  const filteredEducations = educations.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredEducations.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredEducations.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleShowModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setEducationName(item.name);
    } else {
      setEditingItem(null);
      setEducationName("");
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingItem(null);
    setEducationName("");
  };

  const handleAddOrEdit = async () => {
    const trimmed = educationName.trim();
    if (!trimmed) {
      Swal.fire("Validation", "Education name is required!", "warning");
      return;
    }

    setIsActionLoading(true);

    if (editingItem) {
      // PATCH
      try {
        const res = await fetch(`${API_URL}${editingItem.id}/`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });
        if (!res.ok) {
          const error = await res.json();
          Swal.fire("Error", error.detail || "Failed to update", "error");
          return;
        }
        Swal.fire("Updated!", "Education updated successfully.", "success");
        fetchEducations();
        handleCloseModal();
      } catch (err) {
        Swal.fire("Error", "Network error", "error");
      } finally {
        setIsActionLoading(false);
      }
    } else {
      // POST
      try {
        const res = await fetch(API_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });
        if (!res.ok) {
          const error = await res.json();
          Swal.fire("Error", error.detail || "Failed to add", "error");
          return;
        }
        Swal.fire("Added!", "Education added successfully.", "success");
        fetchEducations();
        handleCloseModal();
      } catch (err) {
        Swal.fire("Error", "Network error", "error");
      } finally {
        setIsActionLoading(false);
      }
    }
  };

  const deleteEducation = async (item) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `Delete "${item.name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      setIsDeletingId(item.id);
      try {
        const res = await fetch(`${API_URL}${item.id}/`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) {
          const error = await res.json();
          Swal.fire("Error", error.detail || "Failed to delete", "error");
          return;
        }
        Swal.fire("Deleted!", "Education deleted successfully.", "success");
        fetchEducations();
      } catch (err) {
        Swal.fire("Error", "Network error", "error");
      } finally {
        setIsDeletingId(null);
      }
    }
  };

  return (
    <div>
      <h4 className="mb-3 text-center">Education Management</h4>

      <div className="d-flex justify-content-between mb-3">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
            width: "300px",
          }}
        >
          <FaSearch
            style={{
              position: "absolute",
              left: "10px",
              color: "#888",
            }}
          />
          <input
            type="text"
            placeholder="Search Education..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: "8px 10px 8px 35px",
              border: "1px solid #ddd",
              borderRadius: "5px",
              width: "100%",
            }}
          />
        </div>

        <Button
          onClick={() => handleShowModal()}
          style={{
            background: "linear-gradient(135deg, #ff5baf, #7366ff)",
            color: "white",
            border: "none",
          }}
        >
          + Add Education
        </Button>
      </div>

      {isPageLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Education Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <tr key={item.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.name}</td>
                    <td>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: "none",
                          border: "none",
                          color: "#7366ff",
                          cursor: "pointer",
                        }}
                        onClick={() => handleShowModal(item)}
                      >
                        <Pencil size={20} />
                      </Button>
                      <Button
                        variant="white"
                        size="sm"
                        style={{
                          background: "none",
                          border: "none",
                          color: "#ff5370",
                          cursor: "pointer",
                        }}
                        onClick={() => deleteEducation(item)}
                        disabled={isDeletingId === item.id}
                      >
                        {isDeletingId === item.id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          <FaTrash size={20} />
                        )}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No Education Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          {filteredEducations.length > itemsPerPage && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination>
                <Pagination.First 
                  onClick={() => paginate(1)} 
                  disabled={currentPage === 1} 
                />
                <Pagination.Prev 
                  onClick={() => paginate(currentPage - 1)} 
                  disabled={currentPage === 1} 
                />
                
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => paginate(index + 1)}
                    style={{
                      backgroundColor: index + 1 === currentPage ? 'orange' : '',
                      borderColor: index + 1 === currentPage ? 'orange' : '',
                      color: index + 1 === currentPage ? 'white' : '',
                    }}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                
                <Pagination.Next 
                  onClick={() => paginate(currentPage + 1)} 
                  disabled={currentPage === totalPages} 
                />
                <Pagination.Last 
                  onClick={() => paginate(totalPages)} 
                  disabled={currentPage === totalPages} 
                />
              </Pagination>
            </div>
          )}
        </>
      )}

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingItem ? "Edit Education" : "Add Education"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="educationName">
              <Form.Label>Education Name</Form.Label>
              <Form.Control
                type="text"
                value={educationName}
                onChange={(e) => setEducationName(e.target.value)}
                placeholder="Enter education name"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            disabled={isActionLoading}
          >
            Close
          </Button>
          <Button
            variant="primary"
            style={{
              background: "linear-gradient(135deg, #ff5baf, #7366ff)",
              color: "white",
              border: "none",
            }}
            onClick={handleAddOrEdit}
            disabled={isActionLoading}
          >
            {isActionLoading ? (
              <Spinner size="sm" animation="border" />
            ) : editingItem ? (
              "Save Changes"
            ) : (
              "Add Education"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EducationManager;